/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1
 */
export interface InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1 {
    /**
     * The first name of the member 1
     * @type {string}
     * @memberof InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1
     */
    firstName?: string;
}

/**
 * Check if a given object implements the InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1 interface.
 */
export function instanceOfInvitationContextResponseEnterpriseCompanyMostActiveMembersMember1(value: object): value is InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1 {
    return true;
}

export function InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1FromJSON(json: any): InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1 {
    return InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1FromJSONTyped(json, false);
}

export function InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1FromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1 {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
    };
}

export function InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1ToJSON(value?: InvitationContextResponseEnterpriseCompanyMostActiveMembersMember1 | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
    };
}

